<template>
  <v-container>
    <v-alert type="error" icon="fas fa-exclamation" elevation="2" dense :value="error != ''" dismissible @click="closeAlert">{{error}}</v-alert>
    <v-card elevation="1" outlined class="filterCard">
      <div style="display: inline-flex;">
        <h2 style="margin-bottom: 10px; margin-left: 10px;">Filters</h2>
      </div>
      <div style="display: inline-flex; float: right; margin-right: 10px;">
        <v-btn color="primary" @click="clearFilters()">Clear Filters</v-btn>
      </div>
      <v-row no-gutters>
        <v-col>
          <v-text-field 
            outlined 
            class="flexiFilter" 
            label="Job Reference" 
            v-model="searchedJobReference" 
            @change="onSearchChanged" 
            clearable></v-text-field>
        </v-col>
        <v-col>
          <v-select 
            outlined 
            class="flexiFilter" 
            label="State" 
            :items="states" 
            item-text="StateName" 
            item-value="StateID" 
            v-model="selectedStateID"
            @change="onSearchChanged" 
            clearable
            :menu-props="{ top: false, offsetY: true }"></v-select>
        </v-col>
        <v-col>
          <v-text-field 
            outlined 
            class="flexiFilter" 
            label="location" 
            v-model="searchedLocation" 
            @change="onSearchChanged" 
            clearable></v-text-field>
        </v-col>
        <v-col>
          <v-select
            outlined
            class="flexiFilter"
            label="Report Type"
            :items="reportTypes"
            item-text="ReportTypeName"
            item-value="ReportTypeID"
            v-model="seletedReportTypeID"
            @change="onSearchChanged"
            clearable
            :menu-props="{ top: false, offsetY: true }"></v-select>
        </v-col>
        <v-col>
          <DateRangePicker 
            ref="jobPublishedDatePicker"
            class="flexiFilter"
            @onInput="publishDateInputHandler" 
            title="Publish Date Range">
          </DateRangePicker>
        </v-col>
      </v-row>
    </v-card>
    <ReportList ref="reportListChild" @onLoad="errorHandler" :jobReference="searchedJobReference" :stateID="selectedStateID" :location="searchedLocation" :reportTypeID="seletedReportTypeID" :publishDateFrom="selectedPublishDateFrom" :publishDateTo="selectedPublishDateTo"></ReportList>
  </v-container>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import ReportList from '@/components/reports/ReportList.vue';
import State from '../../../shared/models/state'
import ReportType from '../../../shared/models/reportType'
import Location from '../../../shared/models/location';
import DateRangePicker from '@/components/global/DateRangePicker.vue';
import * as stateAPI from '@/api/stateAPI';
import * as reportTypeAPI from '@/api/reportTypeAPI';
import * as locationAPI from '@/api/locationAPI';
import { vxm } from '@/store';

@Component({
  components: {
    ReportList,
    DateRangePicker
  },
})
export default class ReportsView extends Vue{
  $refs!: {
    reportListChild: ReportList
    jobPublishedDatePicker: DateRangePicker
  }

  @Prop(String) public jobReference!: string | null;
  @Prop(String) public locationName!: string | null;
  @Prop(String) public locationID!: string | null;

  private error = "";
  private searchedJobReference: string | null = null;
  private selectedStateID: number | null = null;
  private searchedLocation: string | null = null;
  private seletedReportTypeID: number | null = null;
  private selectedPublishDateTo: string | null = null;
  private selectedPublishDateFrom: string | null = null;

  private states: State[] = [];
  private reportTypes: ReportType[] = [];

  get selectedClientID() { return  vxm.AuthStore.targetClient?.ClientID; }
  
  @Watch('selectedClientID', { immediate: true, deep: true })
  async onClientIDChanged() {
    this.onSearchChanged();
  }

  private async mounted() {
    try {
      if (this.jobReference != null && this.jobReference != "null")
        this.searchedJobReference = this.jobReference;
      
      if (this.locationID != null && this.locationID != "null") {
        const location: Location = await locationAPI.getLocation(this.locationID);

        this.selectedStateID = location.StateID;
        this.searchedLocation = location.LocationName;
      }
      
      this.states = await stateAPI.getStates();
      this.reportTypes = await reportTypeAPI.getReportTypes();
    }
    catch (ex) {
      this.error = (ex as Error).message;
    }
  }

  private async onSearchChanged() {
    this.$refs.reportListChild?.load();
  }

  private errorHandler(errorMessasge: string) {
    this.error = errorMessasge;
  }

  private publishDateInputHandler(dates: string[] | null) {
    this.selectedPublishDateFrom = dates != null ? dates[0] : null;
    this.selectedPublishDateTo = dates != null && dates.length > 1 ? dates[1] : null;
  
    this.onSearchChanged();
  }

  private closeAlert() {
    this.error = "";
  }

  private clearFilters() {
    this.searchedJobReference = null;
    this.selectedStateID = null;
    this.searchedLocation = null;
    this.seletedReportTypeID = null;
    this.selectedPublishDateTo = null;
    this.selectedPublishDateFrom = null;

    this.$refs.jobPublishedDatePicker.clear_NonEmitting();
    this.$refs.reportListChild.load();
  }
}
</script>

<style>
.flexiFilter {
  margin-left: 10px !important; 
  margin-right: 10px !important; 
  min-width: 200px;
}
.filterCard {
  padding: 12px !important;
  margin-bottom: 30px;
}
</style>